import { Repository } from "react3l-common";
import { kebabCase } from "lodash";
import { httpConfig } from "config/http";
import { BASE_API_URL } from "config/consts";
import { Observable } from "rxjs";
import nameof from "ts-nameof.macro";
import { API_LOGGING_API_PREFIX } from "config/api-consts";
import { LoggingApi, LoggingApiFilter } from "models/LoggingApi";
import {AxiosResponse} from "axios";

export type KeyType = string | number;

export class LogginApiRepository extends Repository {
  constructor() {
    super(httpConfig);
    this.baseURL = new URL(API_LOGGING_API_PREFIX, BASE_API_URL).href;
  }
  public count = (loggingApiFilter?: LoggingApiFilter): Observable<number> => {
    return this.http
      .post<number>(kebabCase(nameof(this.count)), loggingApiFilter)
      .pipe(Repository.responseDataMapper<number>());
  };

  public list = (
    loggingApiFilter?: LoggingApiFilter
  ): Observable<LoggingApi[]> => {
    return this.http
      .post<LoggingApi[]>(kebabCase(nameof(this.list)), loggingApiFilter)
      .pipe(Repository.responseMapToList<LoggingApi>(LoggingApi));
  };

  public get = (id: number | string): Observable<LoggingApi> => {
    return this.http
      .post<LoggingApi>(kebabCase(nameof(this.get)), { id })
      .pipe(Repository.responseMapToModel<LoggingApi>(LoggingApi));
  };

  public create = (loggingApi: LoggingApi): Observable<LoggingApi> => {
    return this.http
      .post<LoggingApi>(kebabCase(nameof(this.create)), loggingApi)
      .pipe(Repository.responseMapToModel<LoggingApi>(LoggingApi));
  };

  public update = (loggingApi: LoggingApi): Observable<LoggingApi> => {
    return this.http
      .post<LoggingApi>(kebabCase(nameof(this.update)), loggingApi)
      .pipe(Repository.responseMapToModel<LoggingApi>(LoggingApi));
  };

  public save = (loggingApi: LoggingApi): Observable<LoggingApi> => {
    return loggingApi.id ? this.update(loggingApi) : this.create(loggingApi);
  };

  public send = (id: number | string): Observable<LoggingApi> => {
    return this.http
      .post<LoggingApi>(kebabCase(nameof(this.send)), { id })
      .pipe(Repository.responseMapToModel<LoggingApi>(LoggingApi));
  };

  public filterListHttpStatusCode = (
    districtFilter: LoggingApiFilter
  ): Observable<LoggingApi[]> => {
    return this.http
      .post<LoggingApi[]>(
        kebabCase(nameof(this.filterListHttpStatusCode)),
        districtFilter
      )
      .pipe(Repository.responseMapToList<LoggingApi>(LoggingApi));
  };

  
      public delete = (loggingApi: LoggingApi): Observable<LoggingApi> => {
          return this.http.post<LoggingApi>(kebabCase(nameof(this.delete)), loggingApi)
              .pipe(Repository.responseMapToModel<LoggingApi>(LoggingApi));
      };
  
      public bulkDelete = (idList: KeyType[]): Observable<void> => {
          return this.http.post(kebabCase(nameof(this.bulkDelete)), idList)
              .pipe(Repository.responseDataMapper());
      };
  

  public export = (filter: any): Observable<AxiosResponse<any>> => {
    return this.http.post("export", filter, {
      responseType: "arraybuffer",
    });
  };
}

export const logginApiRepository = new LogginApiRepository();
